import { Card, MenuButton } from "@velocity-ehs/component-library";
import { OrgUnit } from "./Hierarchies";
import LinkedLocationsTable from "./LinkedLocationsTable";
import { useTranslation } from "react-i18next";

interface EditLinkedLocationsProps {
  orgUnit?: OrgUnit;
  onLinkLocations: () => void;
  onUnlinkLocation: (locationId: string) => void;
  isLoading: boolean;
}

const EditLinkedLocations = ({
  orgUnit,
  onLinkLocations,
  onUnlinkLocation,
  isLoading,
}: EditLinkedLocationsProps): React.ReactElement => {
  const { t } = useTranslation();
  const actionButtons = (): any[] => {
    if (!orgUnit) return [];
    const items = [
      {
        label: t("hierarchies_Link_Locations"),
        command: onLinkLocations,
        show: orgUnit.viewerCanManageOrgUnit,
      },
    ];

    return items.filter((item) => item.show);
  };

  const headerAction = () => {
    if (!orgUnit && actionButtons().length === 0) return <></>;
    return (
      <MenuButton
        label={t("locations_Actions")}
        items={actionButtons()}
        icon="pi-chevron-down"
        buttonClass="p-button-text"
      />
    );
  };

  return (
    <Card
      title={t("universal_Locations")}
      full
      style={{ minWidth: "600px" }}
      headerAction={!isLoading ? headerAction() : undefined}
    >
      <LinkedLocationsTable
        orgUnit={orgUnit}
        isLoading={isLoading}
        isEditMode
        onUnlinkLocation={onUnlinkLocation}
      />
    </Card>
  );
};

export default EditLinkedLocations;
